import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  Checkbox,
  fullName,
  setCaretPosition,
  usernameFromText,
  createMarkup,
  linkify,
  escapeHTML,
  validationStartDate,
} from '../utils';
import '../../../assets/scss/todo.scss';
import Datepicker from 'react-datetime';
import { CalendarIcon, TrashIconSmall } from './Icons';
import { Form, ProgressBar } from 'react-bootstrap';
import PencilIcon from 'mdi-react/PencilIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import Mention from './Mention';
import { flatMap } from 'lodash';
import eventBus from '../../../helper/EventBus';
import AtIcon from 'mdi-react/AtIcon';
import moment from 'moment';
import { toast } from 'react-toastify';
import AssignTo from './AssignToPopOver';
import Avatar from '../components/Avatar';

function TodoItem({ el, index, checkTodo, hideChecked, removeTodo, editTodo, usersList, user }) {
  const [isEdit, setIsEdit] = useState(false);
  const [value, setValue] = useState('');
  const [showUsersList, setShowUsersList] = useState(false);
  const [showAssignToModal, setShowAssignToModal] = useState(false);
  const [editForm, setEditForm] = useState({
    text: '',
    startDate: '',
    dueDate: '',
    assignedUsers: [],
  });

  const commentRef = useRef();

  // console.log(el)

  useEffect(() => {
    if (isEdit) {
      if (commentRef.current) {
        //  resize
        commentRef.current.style.height = '';
        commentRef.current.style.height = commentRef.current.scrollHeight + 2 + 'px';

        commentRef.current.select();
      }
    }
  }, [isEdit]);

  const handleEdit = () => {
    const text = document.createElement('div');
    text.innerHTML = el.text;
    setValue(text.textContent);

    // Initialize edit form with current todo values
    setEditForm({
      text: text.textContent,
      startDate: el.startDate || '',
      dueDate: el.dueDate || '',
      assignedUsers: el.assignedUsers || [],
    });

    setIsEdit(!isEdit);
  };

  const resizeInput = (e) => {
    e.target.style.height = '';
    e.target.style.height = e.target.scrollHeight + 2 + 'px';
  };

  const handleSelectUser = (user) => {
    let comment = commentRef.current.value;
    const selectionStart = commentRef.current.selectionStart;
    const currentSelection =
      selectionStart === comment.length + 1 ? selectionStart - 1 : selectionStart;
    const firstTextBatch = comment.substring(0, currentSelection);
    const secondTextBatch = comment.substring(currentSelection, comment.length + 1);

    const username = `@${fullName(user.name)} `;
    let textToReplace = comment.substring(0, currentSelection).split(/\s+/).pop();
    let newFirstTextBatch;
    newFirstTextBatch = firstTextBatch.replace(new RegExp(`${textToReplace}$`), username);
    // }
    const newText = newFirstTextBatch + secondTextBatch;
    setValue(newText);
    setEditForm((prev) => ({ ...prev, text: newText }));
    setShowUsersList(false);
    setTimeout(() => {
      setCaretPosition(commentRef.current, selectionStart + username.length);
    }, 500);
  };

  const handleOnChange = (e, field = 'text') => {
    if (field === 'text') {
      resizeInput(e);
      console.log("the e: ", e)
      const text = e.target.value;
      const currentSelection = e.target.selectionStart;
      let currentText = text != '' ? text.substring(0, currentSelection) : text;
      const lastWord = currentText
        .replaceAll(/\r?\n|\r/g, ' ')
        .split(' ')
        .splice(-1)[0];

      if (lastWord.startsWith('@')) {
        setShowUsersList(true);
        setTimeout(() => {
          eventBus.dispatch('onSearchUsersInMention', lastWord.replaceAll('@', ''));
        }, 0);
      } else {
        setShowUsersList(false);
      }

      setValue(e.target.value);
      setEditForm((prev) => ({ ...prev, text: e.target.value }));
    } else {
      // Handle date fields
      setEditForm((prev) => ({ ...prev, [field]: e }));
    }
  };

  const validationDueDate = (current) => {
    if (!editForm.startDate) return true;
    return current.isAfter(moment(editForm.startDate).subtract(1, 'day'));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const { text } = await usernameFromText({
      text: linkify(escapeHTML(editForm.text)),
      members: flatMap(usersList),
    });

    // Create updated todo object with all fields
    const updatedTodo = {
      ...el,
      text,
      startDate: editForm.startDate,
      dueDate: editForm.dueDate,
      assignedUsers: editForm.assignedUsers,
    };
    console.log(updatedTodo)

    setIsEdit(false);
    editTodo(index, updatedTodo);
  };

  const todoClick = (e) => {
    const userId = e.target.getAttribute('data-id');
    if (userId && userId !== user._id) eventBus.dispatch('open-chat', userId);
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return null;
    return moment(dateString).format('MMM DD, YYYY');
  };

  // Helper function to check if date is overdue
  const isOverdue = (dueDateString) => {
    if (!dueDateString) return false;
    return moment(dueDateString).isBefore(moment(), 'day') && !el.checked;
  };

  const showUsersLists = (e, users, options = {}) => {
    // Implementation for showing users list - you may need to implement this based on your existing logic
    console.log('Show users list', users);
  };

  return (
    <div
      className={`todo-item no-select ${hideChecked && el.checked ? 'd-none' : ''} ${
        isEdit ? 'is-edit' : ''
      }`}
    >
      <label className='m-0 p-0'>
        <Checkbox checked={el.checked} onChange={(e) => checkTodo(index, e.target.checked)} />
      </label>
      <span className='flex-grow-1 text'>
        {!isEdit ? (
          <div>
            <span
              /*onClick={(e) => checkTodo(index, !el.checked)}*/
              onClick={(e) => todoClick(e)}
              style={el.checked ? { textDecoration: 'line-through' } : {}}
              dangerouslySetInnerHTML={createMarkup(el.text)}
            ></span>

            {/* Display assigned users with Avatar components */}
            {el.assignedUsers && el.assignedUsers.length > 0 && (
              <div className='mt-2 d-flex align-items-center'>
                <small className='text-muted me-2'>Assigned to:</small>
                <div className='members'>
                  <div className='d-flex'>
                    {el.assignedUsers.slice(0, 3).map((assignedUser, idx) => (
                      <React.Fragment key={assignedUser._id || idx}>
                        <Avatar
                          width={30}
                          height={30}
                          user={assignedUser}
                          zIndex={10 - idx}
                        />
                      </React.Fragment>
                    ))}

                    {el.assignedUsers.length > 3 && (
                      <Avatar
                        width={30}
                        height={30}
                        isCounter={true}
                        count={el.assignedUsers.length - 3}
                        zIndex={1}
                        usersList={usersList}
                        showUsersList={(e, users) =>
                          showUsersList(e, users, { ignoreTop: true })
                        }
                      />
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Display dates if they exist */}
            {(el.startDate || el.dueDate) && (
              <div className='mt-2 d-flex align-items-center flex-wrap'>
                {el.startDate && (
                  <small className='text-muted me-3'>
                    {/* <CalendarIcon className='me-1' style={{ width: '12px', height: '12px' }} /> */}
                    Start: {formatDate(el.startDate)}
                  </small>
                )}
                {el.dueDate && (
                  <>
                    <small>---</small>
                    <small
                      className={`me-3 ${isOverdue(el.dueDate) ? 'text-danger' : 'text-muted'}`}
                    >
                      {/* <CalendarIcon className='me-1' style={{ width: '12px', height: '12px' }} /> */}
                      Due: {formatDate(el.dueDate)}
                      {isOverdue(el.dueDate) && <span className='ms-1'>(Overdue)</span>}
                    </small>
                  </>
                )}
              </div>
            )}
          </div>
        ) : (
          <>
            {showUsersList && (
              <div className='position-relative'>
                <Mention
                  usersList={usersList}
                  hideSearchInput={true}
                  inputFocus={false}
                  handleSelectUser={handleSelectUser}
                  style={{ position: 'absolute', bottom: '1rem' }}
                  listStyle={{
                    maxHeight: `${10 + Math.min(index, 3) * 2.5}rem`,
                  }}
                />
              </div>
            )}
            <form className='add-todo' onSubmit={(e) => onSubmit(e)}>
              <div className='d-flex gap-2'>
                <textarea
                  ref={commentRef}
                  rows={1}
                  placeholder='Edit To-do'
                  autoComplete='off'
                  value={value}
                  onChange={(e) => handleOnChange(e, 'text')}
                  autoFocus
                  required
                  className='form-control overflow-hidden border-0 edit-textarea'
                  spellCheck={false}
                ></textarea>
                <div>
                  <button
                    onClick={() => setShowUsersList((oldValue) => !oldValue)}
                    className='btn btn-sm text-secondary'
                    title='Mention'
                    type='button'
                  >
                    <AtIcon />
                  </button>
                </div>
              </div>

              {/* Date fields */}
              <div className='d-flex justify-content-between mt-3'>
                <div className='starting-date'>
                  <Form.Group controlId='Edit Start Date'>
                    <Form.Label>
                      Starting Date<sup className='text-danger'>*</sup>
                    </Form.Label>
                    <Datepicker
                      type='text'
                      closeOnSelect={true}
                      closeOnClickOutside={false}
                      disableOnClickOutside={false}
                      value={editForm.startDate}
                      inputProps={{
                        className: 'form-control datetime',
                        placeholder: 'Select Date',
                      }}
                      onChange={(e) => handleOnChange(e, 'startDate')}
                      isValidDate={validationStartDate}
                      required
                    />
                    <CalendarIcon className='form-icon' />
                  </Form.Group>
                </div>
                <div className='starting-date align-items-center'>
                  <Form.Group controlId='Edit Due Date'>
                    <Form.Label>
                      Due Date<sup className='text-danger'>*</sup>
                    </Form.Label>
                    <Datepicker
                      type='text'
                      closeOnSelect={true}
                      closeOnClickOutside={false}
                      disableOnClickOutside={false}
                      value={editForm.dueDate}
                      inputProps={{
                        className: 'form-control datetime',
                        placeholder: 'Select Date',
                      }}
                      onChange={(e) => handleOnChange(e, 'dueDate')}
                      isValidDate={validationDueDate}
                      required
                    />
                    <CalendarIcon className='form-icon' />
                  </Form.Group>
                </div>
              </div>

              {/* Display assigned users in edit form with Avatar components */}
              {editForm.assignedUsers && editForm.assignedUsers.length > 0 && (
                <div className='mt-2 d-flex align-items-center'>
                  <small className='text-muted me-2'>Currently assigned to:</small>
                  <div className='members'>
                    <div className='d-flex'>
                      {editForm.assignedUsers.slice(0, 3).map((assignedUser, idx) => (
                        <React.Fragment key={assignedUser._id || idx}>
                          <Avatar
                            width={30}
                            height={30}
                            user={assignedUser}
                            zIndex={10 - idx}
                          />
                        </React.Fragment>
                      ))}

                      {editForm.assignedUsers.length > 3 && (
                        <Avatar
                          width={30}
                          height={30}
                          isCounter={true}
                          count={editForm.assignedUsers.length - 3}
                          zIndex={1}
                          usersList={usersList}
                          showUsersList={(e, users) =>
                            showUsersList(e, users, { ignoreTop: true })
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Assign To Modal */}
              <div className='position-relative'>
                <AssignTo
                  show={showAssignToModal}
                  onHide={() => {
                    setShowAssignToModal(false);
                  }}
                  onAssign={(assigningUsers) => {
                    setEditForm((prev) => ({ ...prev, assignedUsers: assigningUsers }));
                  }}
                  persistentSelectedUsers={editForm.assignedUsers}
                  usersList={usersList}
                />
              </div>

              <div className='d-flex justify-content-between mt-3'>
                <button
                  type='button'
                  className='btn btn-outline-primary mr-3 border-2'
                  onClick={() => setShowAssignToModal((prev) => !prev)}
                >
                  Assign to ({editForm.assignedUsers.length})
                </button>
                <div>
                  <button className='btn btn-primary mr-3'>Save</button>
                  <button
                    onClick={() => setIsEdit(false)}
                    className='btn btn-light text-dark'
                    type='button'
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </>
        )}
      </span>
      {!isEdit && (
        <div className='d-flex align-items-center'>
          <button onClick={() => handleEdit()} className='btn action mr-2 edit' title='Edit'>
            {!isEdit ? <PencilIcon title='Edit' /> : <CloseIcon title='Close' />}
          </button>
          <button onClick={(e) => removeTodo(index)} className='btn  action del-btn' title='Delete'>
            <TrashIconSmall />
          </button>
        </div>
      )}
    </div>
  );
}

export function TodoList({
  user,
  showProgress,
  todos = [],
  addTodo,
  checkTodo,
  removeTodo,
  selectAll,
  style,
  canMarkTodo,
  disabled = false,
  editTodo,
  usersList = [],
}) {
  const commentRef = useRef();

  const [showAddForm, setShowAddForm] = useState(false);
  const [todoForm, setTodoForm] = useState({
    text: '',
    assignedUsers: [],
    startDate: new Date(),
    dueDate: moment().add(7, 'days'), // 7 days from now 'DD/MM/YYYY'
  });
  const [textareaHeight, setTextareaHeight] = useState('');
  const [hideChecked, setHideChecked] = useState(false);
  const [showUsersList, setShowUsersList] = useState(false);
  const [todoAssignedUsers, setTodoAssignedUsers] = useState([]);
  const [showAssignToModal, setShowAssignToModal] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    const { text, mentionedUsers } = await usernameFromText({
      text: linkify(escapeHTML(todoForm.text)),
      members: flatMap(usersList),
    });

    console.log(todoForm);
    // Pass all form data to addTodo
    addTodo(
      text,
      mentionedUsers,

      todoForm.assignedUsers, // Note: fixing typo from 'assgnedUsers'
      todoForm.startDate,
      todoForm.dueDate
    );

    // Reset form after submission
    setTodoForm({
      text: '',
      assignedUsers: [],
      startDate: new Date(),
      dueDate: moment().add(7, 'days'),
    });
  };

  const resizeInput = (e) => {
    e.target.style.height = '';
    e.target.style.height = e.target.scrollHeight + 2 + 'px';
  };

  const handleSelectUser = (user) => {
    let comment = commentRef.current.value;
    const selectionStart = commentRef.current.selectionStart;
    const currentSelection =
      selectionStart === comment.length + 1 ? selectionStart - 1 : selectionStart;
    const firstTextBatch = comment.substring(0, currentSelection);
    const secondTextBatch = comment.substring(currentSelection, comment.length + 1);

    const username = `@${fullName(user.name)} `;
    let textToReplace = comment.substring(0, currentSelection).split(/\s+/).pop();
    let newFirstTextBatch;
    newFirstTextBatch = firstTextBatch.replace(new RegExp(`${textToReplace}$`), username);
    // }
    const newText = newFirstTextBatch + secondTextBatch;
    setTodoForm((prev) => ({ ...prev, text: newText }));
    setShowUsersList(false);
    setTimeout(() => {
      setCaretPosition(commentRef.current, selectionStart + username.length);
    }, 500);
  };

  const validationDueDate = (currentDate) => {
    return currentDate.isAfter(moment(todoForm.startDate, 'DD/MM/YYYY').add(-1, 'days'));
  };

  const handleOnChange = (e, field) => {
    if (field === 'text') {
      console.log(e, "the e")
      resizeInput(e);
      // console.log(e, e.target, e.value);
      const text = e.target.value;
      const currentSelection = e.target.selectionStart;
      let currentText = text != '' ? text.substring(0, currentSelection) : text;
      const lastWord = currentText
        .replaceAll(/\r?\n|\r/g, ' ')
        .split(' ')
        .splice(-1)[0];

      if (lastWord.startsWith('@')) {
        setShowUsersList(true);
        setTimeout(() => {
          eventBus.dispatch('onSearchUsersInMention', lastWord.replaceAll('@', ''));
        }, 0);
      } else {
        setShowUsersList(false);
      }
      setTodoForm((prev) => ({ ...prev, text }));
    }
    if (field === 'startDate') {
      const currentDate = moment(e, 'DD/MM/YYYY');
      // if (currentDate.isAfter(todoForm.dueDate)) {
      //   setTodoForm((prev) => ({...prev, dueDate: currentDate }));
      // } else {
      //   alert('Due date must be after start date');
      // }
      setTodoForm((prev) => ({ ...prev, startDate: currentDate }));
    }
    if (field === 'dueDate') {
      const currentDate = moment(e, 'DD/MM/YYYY');
      if (currentDate.isAfter(todoForm.startDate)) {
        setTodoForm((prev) => ({ ...prev, dueDate: currentDate }));
      } else {
        toast.error({ message: 'Due date must be after start date', type: 'error' });
      }
    }
  };

  const completionRate = useCallback((todos) => {
    let total = todos.length;
    let completed = todos.filter((el) => el.checked).length;

    return Math.round((completed / total) * 100);
  }, []);

  const showUsersListHandler = (e, users, options = {}) => {
    // Implementation for showing users list - you may need to implement this based on your existing logic
    console.log('Show users list', users);
  };

  return (
    <div className='todo'>
      {showProgress ? (
        todos.length ? (
          <div className='todo-progress d-flex align-items-center w-100 mb-3'>
            <span>{completionRate(todos)}%</span>
            <ProgressBar className='flex-grow-1 bar' now={completionRate(todos)} />
            <button
              onClick={() => setHideChecked((val) => !val)}
              className='btn text-primary btn-sm'
            >
              {hideChecked ? 'Show' : 'Hide'} Checked To-do
            </button>
          </div>
        ) : (
          <p className='title mb-2'>Track task with a to-do list</p>
        )
      ) : (
        <p className='title mb-2'>Track task with a to-do list</p>
      )}

      <div style={disabled ? { pointerEvents: 'none' } : {}}>
        {todos && todos.length > 2 && !disabled ? (
          <>
            <label className={`todo-item no-select m-0`}>
              <label className='m-0 p-0'>
                <Checkbox
                  checked={todos && todos.every((el) => el.checked)}
                  onChange={(e) => selectAll(e.target.checked)}
                />
              </label>
              <span className='flex-grow-1 text'>Select All</span>
            </label>
            <hr className='my-1' />
          </>
        ) : null}
        {todos.map((el, index) => {
          console.log(el);
          return (
            <div key={index}>
              <TodoItem
                el={el}
                index={index}
                checkTodo={checkTodo}
                hideChecked={hideChecked}
                removeTodo={removeTodo}
                editTodo={editTodo}
                usersList={usersList}
                user={user}
              />
            </div>
          );
        })}
      </div>

      {!disabled ? (
        <div className='mt-2 add-todo'>
          {!showAddForm ? (
            <button
              onClick={() => setShowAddForm(true)}
              className='btn btn-outline-primary border-0'
            >
              + Add To-do
            </button>
          ) : (
            <>
              {showUsersList && (
                <div className='position-relative'>
                  <Mention
                    usersList={usersList}
                    hideSearchInput={true}
                    inputFocus={false}
                    handleSelectUser={handleSelectUser}
                    style={{ position: 'absolute', bottom: '1rem' }}
                    listStyle={{
                      maxHeight: `${10 + Math.min(todos.length, 3) * 2.5}rem`,
                    }}
                  />
                </div>
              )}
              <form key={todos?.length} className='mt-3' onSubmit={(e) => onSubmit(e)}>
                <div className='d-flex gap-2'>
                  <textarea
                    ref={commentRef}
                    style={{ height: textareaHeight }}
                    rows={1}
                    placeholder='Add To-do'
                    value={todoForm.text}
                    autoComplete='off'
                    autoFocus
                    required
                    onChange={(e) => handleOnChange(e, 'text')}
                    spellCheck={false}
                    className='form-control overflow-hidden'
                  ></textarea>
                  <div>
                    <button
                      onClick={() => setShowUsersList((oldValue) => !oldValue)}
                      className='btn btn-sm text-secondary'
                      title='Mention'
                      type='button'
                    >
                      <AtIcon />
                    </button>
                  </div>
                </div>
                <div className='d-flex justify-content-between mt-3'>
                  <div className='starting-date'>
                    <Form.Group controlId='Start Date'>
                      <Form.Label>
                        Starting Date<sup className='text-danger'>*</sup>
                      </Form.Label>
                      {/*<Form.Control type="text" placeholder="Select Date" />*/}

                      <Datepicker
                        type='text'
                        closeOnSelect={true}
                        closeOnClickOutside={false}
                        disableOnClickOutside={false}
                        value={todoForm.startDate}
                        inputProps={{
                          className: 'form-control datetime',
                          placeholder: 'Select Date',
                        }}
                        onChange={(e) => handleOnChange(e, 'startDate')}
                        isValidDate={validationStartDate}
                        required
                      />
                      <CalendarIcon className='form-icon' />
                    </Form.Group>
                  </div>
                  <div className='starting-date align-items-center'>
                    <Form.Group controlId='Start Date'>
                      <Form.Label>
                        Due Date<sup className='text-danger'>*</sup>
                      </Form.Label>
                      {/*<Form.Control type="text" placeholder="Select Date" />*/}

                      <Datepicker
                        type='text'
                        closeOnSelect={true}
                        closeOnClickOutside={false}
                        disableOnClickOutside={false}
                        value={todoForm.dueDate}
                        inputProps={{
                          className: 'form-control datetime',
                          placeholder: 'Select Date',
                        }}
                        onChange={(e) => handleOnChange(e, 'dueDate')}
                        isValidDate={validationDueDate}
                        required
                      />
                      <CalendarIcon className='form-icon' />
                    </Form.Group>
                  </div>
                </div>

                {/* Display assigned users in add form with Avatar components */}
                {todoForm.assignedUsers && todoForm.assignedUsers.length > 0 && (
                  <div className='mt-2 d-flex align-items-center'>
                    <small className='text-muted me-2'>Will be assigned to:</small>
                    <div className='members'>
                      <div className='d-flex'>
                        {todoForm.assignedUsers.slice(0, 3).map((assignedUser, idx) => (
                          <React.Fragment key={assignedUser._id || idx}>
                            <Avatar
                              width={30}
                              height={30}
                              user={assignedUser}
                              zIndex={10 - idx}
                            />
                          </React.Fragment>
                        ))}

                        {todoForm.assignedUsers.length > 3 && (
                          <Avatar
                            width={30}
                            height={30}
                            isCounter={true}
                            count={todoForm.assignedUsers.length - 3}
                            zIndex={1}
                            usersList={usersList}
                            showUsersList={(e, users) =>
                              showUsersListHandler(e, users, { ignoreTop: true })
                            }
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className='position-relative'>
                  <AssignTo
                    show={showAssignToModal}
                    onHide={() => {
                      setShowAssignToModal(false);
                    }}
                    onAssign={(assigningUsers) => {
                      setTodoAssignedUsers(assigningUsers);
                      setTodoForm((prev) => ({ ...prev, assignedUsers: assigningUsers }));
                    }}
                    persistentSelectedUsers={todoAssignedUsers}
                    usersList={usersList}
                    // selectedUsers={todoAssignedUsers}
                  />
                </div>
                <div className='d-flex justify-content-between mt-3'>
                  <button
                    type='button'
                    className='btn btn-outline-primary mr-3 border-2'
                    onClick={() => setShowAssignToModal((prev) => !prev)}
                  >
                    Assign to ({todoForm.assignedUsers.length})
                  </button>
                  <div>
                    <button className='btn btn-primary mr-3'>Add</button>
                    <button
                      onClick={() => setShowAddForm(false)}
                      className='btn btn-light text-dark'
                      type='button'
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </>
          )}
        </div>
      ) : null}
    </div>
  );
}